import React, { useState } from "react";
import apiClient from "../../utils/apiclient";

const Index = () => {
  const [starttime, setStarttime] = useState("");
  const [endtime, setEndtime] = useState("");
  const [Userid, SetUserId] = useState("")
  const [Coupon, SetCoupon] = useState("")

  const [useBBCurrency, setUseBBCurrency] = useState(false);
  const [onlinePayment, setOnlinePayment] = useState(false);

  const [itemDetails, setItemDetails] = useState([
    { itemid: "", count: 1 },
  ]);

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...itemDetails];
    updatedItems[index][field] = value;
    setItemDetails(updatedItems);
  };

  const addItem = () => {
    setItemDetails([...itemDetails, { itemid: "", count: 1 }]);
  };

  const removeItem = (index) => {
    setItemDetails(itemDetails.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    // 👉 call API here
    try {
      e.preventDefault();

      const payload = {

        starttime,
        endtime,
        itemDetails,
        useBBCurrency,
        onlinePayment,
        couponId: Coupon || null
      };

      console.log("Order Payload:", payload);

      const response = await apiClient.post(`/create/order/${Userid}`,
        payload
      );
      console.log(response.data)
      alert("Order created successfully");
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4 overflow-auto px-2 md:px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-4xl bg-white border border-gray-300 shadow-sm">
        <div className="bg-gray-800 text-white px-4 py-2 sticky top-0 z-10 shadow-md">
          <h2 className="text-sm md:text-base font-bold">Create One-Time Order</h2>
        </div>

        <div className="p-3 md:p-5 flex flex-col gap-4">
          <div className="flex flex-col md:flex-row gap-2 md:items-center">
            <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">User ID</label>
            <input
              className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
              type="text"
              placeholder="User ID"
              value={Userid}
              onChange={(e) => SetUserId(e.target.value)}
              required
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
              <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">Start Time</label>
              <input
                className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                type="time"
                value={starttime}
                onChange={(e) => setStarttime(e.target.value)}
                required
              />
            </div>
            <div className="flex flex-1 flex-col md:flex-row gap-2 md:items-center">
              <label className="text-[10px] md:text-sm font-semibold md:w-20 flex-shrink-0 text-gray-700">End Time</label>
              <input
                className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                type="time"
                value={endtime}
                onChange={(e) => setEndtime(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="border border-gray-300 mt-2">
            <div className="bg-gray-100 px-3 py-2 flex justify-between items-center border-b border-gray-300">
              <h3 className="text-[10px] md:text-sm font-bold text-gray-700">Order Items</h3>
              <button
                type="button"
                className="text-[10px] md:text-xs bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 transition"
                onClick={addItem}
              >
                + Add Item
              </button>
            </div>

            <div className="p-2 flex flex-col gap-2 bg-gray-50 max-h-48 overflow-y-auto">
              {itemDetails.map((item, index) => (
                <div key={index} className="flex gap-2 items-center">
                  <input
                    className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="text"
                    placeholder="Item ID"
                    value={item.itemid}
                    onChange={(e) => handleItemChange(index, "itemid", e.target.value)}
                    required
                  />
                  <input
                    className="w-16 md:w-24 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
                    type="number"
                    placeholder="Qty"
                    min="1"
                    value={item.count}
                    onChange={(e) => handleItemChange(index, "count", Number(e.target.value))}
                    required
                  />
                  {itemDetails.length > 1 && (
                    <button
                      type="button"
                      className="text-red-600 text-lg leading-none hover:text-red-800 px-2"
                      onClick={() => removeItem(index)}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-4 mt-2">
            <label className="flex items-center gap-2 text-[10px] md:text-sm text-gray-700 cursor-pointer">
              <input
                type="checkbox"
                className="w-3 h-3 md:w-4 md:h-4 cursor-pointer"
                checked={useBBCurrency}
                onChange={(e) => setUseBBCurrency(e.target.checked)}
              />
              Use BB Currency
            </label>
            <label className="flex items-center gap-2 text-[10px] md:text-sm text-gray-700 cursor-pointer">
              <input
                type="checkbox"
                className="w-3 h-3 md:w-4 md:h-4 cursor-pointer"
                checked={onlinePayment}
                onChange={(e) => setOnlinePayment(e.target.checked)}
              />
              Online Payment
            </label>
          </div>

          <div className="flex flex-col md:flex-row gap-2 md:items-center mt-2">
            <label className="text-[10px] md:text-sm font-semibold w-24 flex-shrink-0 text-gray-700">Coupon ID</label>
            <input
              className="flex-1 px-2 py-1 text-[10px] md:text-sm border border-gray-400 rounded focus:outline-none focus:border-blue-500"
              type="text"
              placeholder="Optional Coupon ID"
              value={Coupon}
              onChange={(e) => SetCoupon(e.target.value)}
            />
          </div>

          <div className="mt-4 flex justify-end">
            <button
              type="submit"
              className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded transition"
            >
              Submit Order
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Index;
